import { map, Observable, Subject } from "@pjs/observables";
import { createGuid } from "@pjs/utilities";
import { a11yI18n } from "../i18n/A11yI18n.const";
import { IAction } from "./interfaces/IAction";
import { IActionLogger } from "./interfaces/IActionLogger";

export class ActionLogger implements IActionLogger {
    public readonly actionExpiryTime: number;
    public readonly expiryCheckInterval: number;

    private _actions: Array<IAction> = [];
    private readonly _actionsSubject: Subject<ReadonlyArray<IAction>>;
    private _intervalId: number = -1;

    constructor(actionDuration: number, expiryInterval: number) {
        this.actionExpiryTime = actionDuration;
        this.expiryCheckInterval = expiryInterval;
        this._actionsSubject = new Subject();
    }

    public append(text: string): void {
        if (this._intervalId === -1) {
            this._setupExpirationTimer();
        }

        const timestamp = Date.now();
        const formattedTimeStamp = new Date(timestamp).toLocaleTimeString(a11yI18n.getLanguage(), { hour: "2-digit", minute: "2-digit" });
        this._actions.push({
            id: createGuid(),
            text: a11yI18n.getString("action_logger.action_message", { message: text, timeStamp: formattedTimeStamp }),
            timeStamp: timestamp
        });
        this._actionsSubject.next(this._actions);
    }

    public observe(): Observable<ReadonlyArray<IAction>> {
        const initialSetupTimestamp = Date.now();
        return this._actionsSubject.pipe(
            map((actions) =>
                actions.filter((action) => {
                    return action.timeStamp >= initialSetupTimestamp;
                })
            )
        );
    }

    private _setupExpirationTimer(): void {
        this._intervalId = window.setInterval(() => {
            const numActions = this._actions.length;
            this._actions = this._actions.filter((action) => action.timeStamp + this.actionExpiryTime >= Date.now());

            if (this._actions.length !== numActions) {
                this._actionsSubject.next(this._actions);

                if (this._actions.length === 0) {
                    window.clearInterval(this._intervalId);
                    this._intervalId = -1;
                }
            }
        }, this.expiryCheckInterval);
    }
}
